// extracted by mini-css-extract-plugin
module.exports = {"expertise":"Expertise_expertise__1y0LZ","divider":"Expertise_divider__G2Ptc","list":"Expertise_list__1Bmqf"};